import React from "react";
import { useTheme } from "react-jss";
import useStyles from "./TableFooter.styles";
import { PaginatedTableProps } from "./PaginatedTable";
import { TablePagination } from "./TablePagination";
import { TinySelect } from "../select/TinySelect";

interface FooterProps {
    children: React.ReactNode;
    rowsPerPage: number;
    tableProps: PaginatedTableProps;
    currentPage: number;
    pageCount: number;
    lengthMenuText: string;
    onChangeRowsPerPage(value: number);
}

export function TableFooter(props: FooterProps) {
    const {
        children,
        rowsPerPage,
        tableProps,
        onChangeRowsPerPage,
        currentPage,
        pageCount,
        lengthMenuText,
    } = props;
    const { rowsPerPageOptions } = tableProps;
    const theme = useTheme();
    const classes = useStyles({ theme });
    const [displayText, itemsText] = lengthMenuText.split("_MENU_");
    return (
        <div className={classes.footer}>
            <div className={classes.pageInfo} role="status" aria-live="polite">
                {children}
            </div>
            <div className={classes.flex} />
            <div className={classes.rowsPerPage}>
                {displayText}
                <TinySelect
                    value={String(rowsPerPage)}
                    options={rowsPerPageOptions.map(String)}
                    onChange={(value) => onChangeRowsPerPage(parseInt(value, 10))}
                />
                {itemsText}
            </div>
            <TablePagination
                currentPage={currentPage}
                pageCount={pageCount}
                rowsPerPage={rowsPerPage}
                tableProps={tableProps}
            />
        </div>
    );
}
